'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var THREAD_LIST = exports.THREAD_LIST = 'thread-list';
var THREAD_VIEW = exports.THREAD_VIEW = 'thread-view';


//////////////////
// WEBPACK FOOTER
// ./js/current-view/constants/views.js
// module id = 126
// module chunks = 2 3